module.exports = __webpack_public_path__ + "img/mystic-miners-3.5763211c.png";